import { ESearchModalState } from '../../../../../types/searchModal';

export function getSearchModalEmptyText(state: ESearchModalState) {
  switch (state) {
    case ESearchModalState.EmptySuggest:
      return `Мы не нашли то, что вы искали.\nПопробуйте написать по–другому`;
    case ESearchModalState.SuggestError:
      return `Во время поиска произошла ошибка.\nПопробуйте повторить позднее`;
    case ESearchModalState.EmptyTags:
      return 'Ищите акции и скидки по определенному ЖК, банку или застройщику';
    default:
      return null;
  }
}
